import { EventEmitter } from 'events';

export type AuthEventType = 'refreshPermissions' | 'logout';

class AuthEventEmitter extends EventEmitter {
  emit(event: AuthEventType): boolean {
    return super.emit(event);
  }

  on(event: AuthEventType, listener: () => void): this {
    return super.on(event, listener);
  }

  off(event: AuthEventType, listener: () => void): this {
    return super.off(event, listener);
  }
}

export const authEvents = new AuthEventEmitter();
